<span v-translate="getTranslateError"></span>